/**
 * FormHeader Component
 *
 * Displays the transaction form header with type indicator and change type button
 */
import styles from './FormHeader.module.css';

function FormHeader({ transactionType, useTemplateForIncome, onCancel }) {
    return (
        <div className={styles.header}>
            <h4 className={styles.title}>
                Adding {transactionType}
                {transactionType === 'Income' && useTemplateForIncome && (
                    <span className={styles.templateBadge}>
                        TEMPLATE
                    </span>
                )}
            </h4>
            <button
                onClick={onCancel}
                className={styles.changeTypeButton}
            >
                Change Type
            </button>
        </div>
    );
}

export default FormHeader;
